<template>
  <div class="jps-license-summary"
    :class="{
      'page-hina': isHina,
      'page-jps': isJps,
    }"
  >
    <div class="guideline-contents">
      <div>
        <p class="heading is-size-7 has-text-weight-bold">
          {{ ls({ ja: '教育', en: 'EDUCATIONAL' }) }}
        </p>
        <p class="jps-rights-summary-ok" v-if="summary.educational === 'ok'">
          <BaseIcon
            size="size-1"
            :class="{ 'jps-key-blue': isJa }"
            :name="okIcon"
            alt="規約に従うことで制限なく利用できる"
          />
        </p>
        <p
          class="jps-rights-summary-conditional"
          v-if="summary.educational === 'conditional'"
        >
          <BaseIcon size="size-1" :name="condIcon" alt="利用用途に一定の制約がある" />
        </p>
        <p
          class="jps-rights-summary-ng"
          v-if="summary.educational === 'ng'"
        >
          <BaseIcon size="size-1" :name="ngIcon" alt="利用できない" />
        </p>
        <p
          class="jps-rights-summary-na"
          v-if="summary.educational === 'na'"
        >
          <BaseIcon size="size-1" :name="noneIcon" alt="利用条件に関する情報がない" />
        </p>
      </div>
      <div>
        <p class="heading is-size-7 has-text-weight-bold">
          {{ ls({ ja: '非商用', en: 'NON-COMMERCIAL' }) }}
        </p>
        <p
          class="jps-rights-summary-ok"
          v-if="summary.nonCommerce === 'ok'"
        >
          <BaseIcon
            size="size-1"
            :class="{ 'jps-key-blue': isJa }"
            :name="okIcon"
            alt="規約に従うことで制限なく利用できる"
          />
        </p>
        <p
          class="jps-rights-summary-conditional"
          v-if="summary.nonCommerce === 'conditional'"
        >
          <BaseIcon size="size-1" :name="condIcon" alt="利用用途に一定の制約がある" />
        </p>
        <p
          class="jps-rights-summary-ng"
          v-if="summary.nonCommerce === 'ng'"
        >
          <BaseIcon size="size-1" :name="ngIcon" alt="利用できない" />
        </p>
        <p
          class="jps-rights-summary-na"
          v-if="summary.nonCommerce === 'na'"
        >
          <BaseIcon size="size-1" :name="noneIcon" alt="利用条件に関する情報がない" />
        </p>
      </div>
      <div>
        <p class="heading is-size-7 has-text-weight-bold">
          {{ ls({ ja: '商用', en: 'COMMERCIAL' }) }}
        </p>
        <p
          class="jps-rights-summary-ok"
          v-if="summary.commerce === 'ok'"
        >
          <BaseIcon
            size="size-1"
            :class="{ 'jps-key-blue': isJa }"
            :name="okIcon"
            alt="規約に従うことで制限なく利用できる"
          />
        </p>
        <p
          class="jps-rights-summary-conditional"
          v-if="summary.commerce === 'conditional'"
        >
          <BaseIcon size="size-1" :name="condIcon" alt="利用用途に一定の制約がある" />
        </p>
        <p
          class="jps-rights-summary-ng"
          v-if="summary.commerce === 'ng'"
        >
          <BaseIcon size="size-1" :name="ngIcon" alt="利用できない" />
        </p>
        <p
          class="jps-rights-summary-na"
          v-if="summary.commerce === 'na'"
        >
          <BaseIcon size="size-1" :name="noneIcon" alt="利用条件に関する情報がない" />
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SVG_NAMES } from '~/components/icons'
import { useRightsData } from '~/components/ui/rights/useRightsData'

const { ls, isJa } = useI18n()
const { getRightsSummary } = useRightsData()
const { isHina, isJps } = useServiceType()

interface Props {
  rights: string
}

const props = withDefaults(defineProps<Props>(), {})

const summary = computed(() => {
  return getRightsSummary(props.rights)
})

const okIcon = computed<SVG_NAMES>(() => {
  return isJa.value ? 'mdi/panorama-fisheye' : 'mdi/check-circle'
})

const condIcon = computed<SVG_NAMES>(() => {
  return 'mdi/alert'
})

const ngIcon = computed<SVG_NAMES>(() => {
  return 'mdi/minus-circle'
})

const noneIcon = computed<SVG_NAMES>(() => {
  return 'mdi/minus'
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-license-summary {
  .jps-rights-summary-ok {
    color: $jps-key-green;
  }
  .jps-rights-summary-conditional {
    color: $jps-sub-orange;
  }
  .jps-rights-summary-ng {
    color: $jps-key-red;
  }
  .jps-rights-summary-na {
    color: $jps-gray-600;
  }
  .jps-key-blue {
    color: $jps-key-blue;
  }
  .guideline-contents {
    display: flex;
    justify-content: center;
    margin-bottom: 0.5rem;
    .jps-icon {
      display: block;
      font-size: 3rem;
    }
    > div {
      min-width: 6rem;
      text-align: center;
      .heading {
        margin-bottom: 0;
        letter-spacing: 0;
      }
    }
  }
}

.page-hina {
  .guideline-contents {
    > div {
      .heading {
        color: $jps-gray-700;
      }
    }
  }
}
</style>
